import React from 'react';

import FlightSearch from './FlightSearch';
import Header from '../../Components/Header';
// import Search from '../../Products/Flight/Search';

const Flight = () => {
   
  return(
  <>
  {/* Search Form Sart */}
  <Header />
  {/* <Search /> */}
  <FlightSearch />
  {/* Search Form End */}
<section class="footer_top"> 
		<div class="container">
		<div class="_toprflcont mb-8">
			<div class="_hdrtxt">Quick Links </div>
		</div>
     <div class="col-md-12">
        <div class="d-flex-bus">
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/delhi.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Delhi</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Mumbai.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Mumbai</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Bangalore.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Bangalore</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Dubai.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Dubai</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/London.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>London</h5>
                </a>
            </div>
           
           
        </div>
     </div>
           
            
        </div>    
    </section>
    {/* <section className='home_benefits space-padding'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='hGsgst'></div>
            <h1>Better Control & Benefits <br /><span>Compared to Other Platforms</span></h1>
          </div>
          <div className='col-md-4 col-lg-4 home_benft_A'>
            <div className='home_benft_A_img_box'>
              <img src="/assets/images/Fare.jpg" alt="img" className='home_benft_A_img'  />
            </div>
            <h3>Special Fare</h3>
            <p>We have included many benefits in your corporate fare to make your travel
               experience memorable.</p>
          </div>

          <div className='col-md-4 col-lg-4 home_benft_A'>
            <div className='home_benft_A_img_box'>
              <img src="/assets/images/Tax.jpg" alt="img" className='home_benft_A_img' />
            </div>
            <h3>Tax Benefits with GST Invoices</h3>
            <p>Stay assured with guranteed GST invoices on flights, hotels* & cabs, downloadable with a single click</p>
          </div>
          <div className='col-md-4 col-lg-4 home_benft_A'>
            <div className='home_benft_A_img_box'>
              <img src="/assets/images/Expense.jpg" alt="img" className='home_benft_A_img' />
            </div>
            <h3>Expense Management</h3>
            <p>Simplest way of keeping a track of all your employee’s expenses and reimbursements</p>
          </div>

        </div>
      </div>
    </section> */}


  </>

)
};

export default Flight;
